import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {setUser, useAppDispatch, User, userService} from "@shared/ui";
import { useTranslation } from "react-i18next";

const FormCode: React.FC<{email: string, setShowEmailModal: (value: boolean) => void}> = ({email, setShowEmailModal}) => {
  const { t } = useTranslation();
  const [isCodeError, setIsCodeError] = useState(false);
  const dispatch = useAppDispatch();

  type FormValues = {
    code: number;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {
    userService.verifyEmailCode(email, data.code).then((data: User) => {
      if (data) {
        setShowEmailModal(false);
        dispatch(setUser(data));
      }

    }).catch(() => {
      setIsCodeError(true);
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <label htmlFor="code">{t("formCode.label")}</label>
      <input
        id="code"
        type="text"
        {...register("code", {
          required: t("formCode.errors.codeRequired"),
          pattern: {
            value: /^\d+$/,
            message: t("formCode.errors.codeDigitsOnly"),
          },
        })}
      />
      {errors.code && <span className="error">{errors.code.message}</span>}
      {isCodeError && <span className="error">{t("formCode.errors.codeInvalid")}</span>}

      <input type="submit" value={t("formCode.submit")} />
    </form>
  )
};

export default FormCode;
